import axiosInstance from 'api/axiosInstance';

const deleteDocument = (documentId: string) =>
  axiosInstance.delete(`/v2/repository-documents/${documentId}`);

export default deleteDocument;
